import React, { useCallback } from 'react';

import RemoteAutocomplete from './RemoteAutocomplete';

const buildJobUrl = (search, groupId) => {
  const params = new URLSearchParams({ limit: '20', sort: '-id' });
  if (Number(groupId) > 0) {
    params.set('gid', String(Number(groupId)));
  }
  if (search) {
    params.set('q', search);
  } else if (!Number(groupId)) {
    params.set('status', 'active');
  }
  return `/jobs?${params.toString()}`;
};

const JobIdAutocomplete = ({ groupId, name, value, onChange, sx }) => {
  const buildUrl = useCallback((search) => buildJobUrl(search, groupId), [groupId]);

  return (
    <RemoteAutocomplete
      buildUrl={buildUrl}
      getOptionKey={(option) => option.id}
      getOptionLabel={(option) => String(option.id)}
      getOptionValue={(option) => option.id}
      hydrateSelectedOption
      name={name}
      onChange={onChange}
      renderOptionLabel={(option) => `${option.id} - ${option.name}`}
      sx={sx}
      value={value}
    />
  );
};

export default JobIdAutocomplete;
